import { BoundRichTextField, Css, FormLines, type Properties } from "@homebound/beam";
import { ObjectConfig, useFormState } from "@homebound/form-state";
import { ReactNode } from "react";
import "src/components/RichTextFieldOverrides.css";
import { richTextMinHeight, richTextScroll } from "src/components/RichTextFieldOverrides.css";
import { CommitmentStatus, SaveCommitmentInput } from "src/generated/graphqlTypes";
import { CommitmentEditorDataFragment } from "src/routes/projects/commitments/CommitmentPage.generated";
import { useSaveNewCommitmentMutation } from "src/routes/projects/commitments/components/NewCommitmentModal.generated";
type ScheduleAndScopeTabProps = { commitment: CommitmentEditorDataFragment };

export function ScheduleAndScopeTab({ commitment }: ScheduleAndScopeTabProps) {
  const [saveCommitment] = useSaveNewCommitmentMutation();

  const isSigned = commitment.status === CommitmentStatus.Signed;

  const { costTypes, ...commitmentWithoutCostType } = commitment;

  const formState = useFormState({
    config: formConfig,
    init: { onlyOnce: true, input: commitmentWithoutCostType },
    autoSave: async (c) => {
      if (commitment && !isSigned) {
        await saveCommitment({ variables: { input: c.changedValue } });
      }
    },
    readOnly: isSigned,
  });

  return (
    <>
      <FormWrapper>
        <FormLines width="lg">
          <div css={Css.className(richTextScroll).className(richTextMinHeight).$}>
            <BoundRichTextField field={formState.contractSchedule} label="Schedule" />
          </div>
          <div css={Css.className(richTextScroll).$}>
            <BoundRichTextField field={formState.contractExhibits} label="Drawings and Exhibits" />
          </div>
          <div css={Css.className(richTextScroll).$}>
            <BoundRichTextField field={formState.contractExclusions} label="Exclusions (Optional)" />
          </div>
          <div css={Css.className(richTextScroll).$}>
            <BoundRichTextField field={formState.contractTerms} label="Terms &amp; Conditions" />
          </div>
        </FormLines>
      </FormWrapper>
    </>
  );
}

type FormInput = Omit<SaveCommitmentInput, "commitmentType">;

const formConfig: ObjectConfig<FormInput> = {
  id: { type: "value" },
  contractExclusions: { type: "value" },
  contractExhibits: { type: "value" },
  contractSchedule: { type: "value" },
  contractTerms: { type: "value" },
};

function FormWrapper(props: { children: ReactNode; xss?: Properties }) {
  const { children, xss } = props;
  return <form css={xss}>{children}</form>;
}
